module.exports = __webpack_public_path__ + "static/media/flag-pt.6918c746.svg";